/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpack_Buy1Inputs */

const zh_creditpack_buy1 = /** @type {(inputs: Creditpack_Buy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买`)
};

const en_creditpack_buy1 = /** @type {(inputs: Creditpack_Buy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy`)
};

const es_creditpack_buy1 = /** @type {(inputs: Creditpack_Buy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar`)
};

/**
* | output |
* | --- |
* | "Buy" |
*
* @param {Creditpack_Buy1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const creditpack_buy1 = /** @type {((inputs?: Creditpack_Buy1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpack_Buy1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_creditpack_buy1(inputs)
	if (locale === "en") return en_creditpack_buy1(inputs)
	return es_creditpack_buy1(inputs)
});
export { creditpack_buy1 as "creditPack_buy" }